export default __webpack_public_path__ + "static/media/main-bg-item-mobile.6cfe8ffb.png";